<template>
  <div class="goods-comments">
    <div class="goods-comments__user">
      <div><img :src="data.user.photo"></div>
      <div class="add_dot">{{ data.user.nickName }}</div>
      <div>{{ data.date }}</div>
    </div>
    <div class="goods-comments__star">
      <i v-for="(item,index) in allStars" :key="index" :class="['icon',item]"></i>
    </div>
    <div class="goods-comments__comments">
      {{ data.content ? data.content : '此用户没有填写评论' }}
    </div>
    <div v-if="data.sourceData" class="goods-comments__sku">
      <span>{{ data.sourceData }}</span>
    </div>
    <div v-if="data.images.length" class="goods-comments__img">
      <div v-for="(item, index) in data.images" :key="index" @click="showPreview(index,data.images)">
        <img :src="item.small">
      </div>
    </div>
    <!--    <div class="goods-comments__shop-comment" v-if="shopComments">-->
    <!--      <span>掌柜回复:</span>-->
    <!--      {{shopComments}}-->
    <!--    </div>-->
  </div>
</template>
<script>

export default {
  props: ['data'],
  data() {
    return {
      isPreviewGoods: false,
      defaultImgIndx: 0,
      allStars: ['gray_star', 'gray_star', 'gray_star', 'gray_star', 'gray_star'],
    };
  },
  watch: {
    'data.point': {
      handler(val) {
        const { allStars } = this;
        if (typeof val === 'number') {
          for (let i = 0; i < allStars.length; i += 1) {
            if (i <= (val - 1)) {
              allStars[i] = 'light_star';
            } else {
              allStars[i] = 'gray_star';
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    showIndex() {
      const { defaultImgIndx, goodsDetail: { img } } = this;
      if (Array.isArray(img)) {
        return `${defaultImgIndx + 1}/${img.length}`;
      }
      return '';
    },
    shopComments() {
      const { reply_list } = this.data;
      if (Array.isArray(reply_list) && reply_list.length) {
        return reply_list.sort((a, b) => b.add_time - a.add_time)[0].content;
      }
    },
  },
  methods: {

    getImgIndex(index) {
      this.defaultImgIndx = index;
    },
    showPreview(index, images) {
      const showBigImg = [];
      images.forEach((item) => {
        showBigImg.push(item.big);
      });
      this.$emit('showBigImg', { index, showBigImg });
    },
  },
};
</script>

<style lang="scss">
@import "~assets/css/common.scss";

.goods-comments {
  padding: 20px 30px 10px 30px;
  background: #fff;
  border-bottom: 2px solid rgba(211, 211, 211, 0.5);

  &__user {
    display: flex;

    div {
      height: 74px;
      line-height: 74px;
    }

    div:nth-child(1) {
      width: 74px;
      border-radius: 50%;
      margin-right: 27px;

      img {
        max-width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    div:nth-child(2) {
      flex: 1;
      font-size: 30px;
      color: #000000;
    }

    div:nth-child(3) {
      font-size: 24px;
      color: #000000;
      min-width: 180px;
      margin-left: 30px;
      text-align: right;
    }
  }

  &__star {
    display: flex;
    height: 60px;
    align-items: center;

    i {
      margin-right: 12px;
    }
  }

  &__comments {
    font-size: 28px;
    color: #000000;
    margin-bottom: 20px;
  }

  &__sku {
    height: 33px;
    font-size: 24px;
    color: #6c6c6c;
    margin-bottom: 20px;

    span + span {
      margin-left: 20px;
    }
  }

  &__img {
    display: flex;
    flex-wrap: wrap;

    div {
      width: 172px;
      height: 172px;
      flex-shrink: 0;
      margin-right: 26px;
      margin-bottom: 26px;
      text-align: center;

      img {
        height: 100%;
        max-width: 100%;
      }
    }
  }

  &__shop-comment {
    margin-top: 10px;
    padding: 16px 24px;
    font-size: 26px;
    color: #696969;
    background: rgba(249, 249, 249, 1);
    border-radius: 2px 0px 0px 0px;
    position: relative;

    span {
      font-weight: bold;
    }

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 60px;
      top: -20px;
      width: 0px;
      height: 0px;
      border-width: 0 20px 20px;
      border-style: solid;
      border-color: #fff #fff #F9F9F9;
      background: #F9F9F9;
    }
  }

  &__nomargin {
    margin-left: 0 !important;
  }
}
</style>
